import { ActionButtons, Footer } from "@ucl/library";
import { TaskExecutionModuleProps } from "../TaskExecutionModuleProps";
import { TaskExecutionFieldsLoader } from "../../TaskExecutionComponent/TaskExecutionFieldsLoader";
import { useState } from "react";
import { TaskExecutionTypeFieldSchema } from "@bolt/core";

export const GeneralTaskExecutionTypeModule: React.FC<
  TaskExecutionModuleProps
> = (props) => {
  const [fieldsErrors] = useState<Record<string, string[]>>({});
  const [fieldsSubmittedData, setFieldsSubmittedData] =
    useState<TaskExecutionTypeFieldSchema>({});

  const handleFieldsSubmit = async (updated: TaskExecutionTypeFieldSchema) => {
    setFieldsSubmittedData(updated);
  };

  return (
    <div className="general-task-execution-type-module">
      {props.taskExecutionTypeFields && (
        <TaskExecutionFieldsLoader
          taskExecutionType={props.taskExecutionType}
          taskExecutionTypeFields={props.taskExecutionTypeFields}
          apiBaseUrl={props.apiBaseUrl}
          getAuthRequestHeader={props.getAuthRequestHeader}
          onSubmit={handleFieldsSubmit}
          errors={fieldsErrors}
          isReadOnly={props.isReadOnly}
        />
      )}
      <Footer>
        {!props.isReadOnly ? (
          <ActionButtons
            actions={[
              {
                text: "Complete",
                isPrimary: true,
                onActionClick: () => {
                  props.onTaskComplete?.(fieldsSubmittedData);
                },
              },
            ]}
          />
        ) : (
          <></>
        )}
      </Footer>
    </div>
  );
};
